import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { publicAPI, privateAPI } from "../../../utils/api";
import HideImageIcon from "@mui/icons-material/HideImage";
import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import DiscountIcon from "@mui/icons-material/Discount";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { ImageBlockWrapper } from "../styles";
import CloseX from "../../CloseX";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import InputLabel from '@mui/material/InputLabel';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import debounce from "lodash/debounce";

const CreateEditProductDialog = ({ ...props }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openGroupList, setOpenGroupList] = useState(false);
  const label = { inputProps: { "aria-label": "Discount Mark" } };
  const [allGroups, setAllGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const typeOfProduct = [ 'RED', 'WHITE', 'PROSSECO', 'COCKTAILS', "WINES" ];
  const richTextDesc = [{lng: 'EN', lngSml: 'en'}, {lng: 'DE', lngSml: 'de'}, {lng: 'IT', lngSml: 'it'}, {lng: 'FR', lngSml: 'fr'}]

  const updateRichTextContent = (value, lngSml) => {
    // Debounce the state update to avoid too many re-renders
    const update = debounce(() => {
      props.setProductDTO({ ...props.productDTO, [lngSml === 'en' ? 'description' : `description_${lngSml}`]: value });
    }, 300);
    update();
  };

  const handleUpload = async (e) => {
    const file = Array.from(e.target.files)[0];

    // const isImage = /(?:jpg|jpeg|gif|png)/.test(file.type);
    // if (file.size > IMAGE_SIZE) {
    //     setLoading(false);
    //     toast.warn('Image size need to be less than 5mb...');
    //     return;
    // } else if (!isImage) {
    //     setLoading(false);
    //     toast.info('File type need to be jpg, gif or png...');
    //     return;
    // }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoadingImage(true);
      const response = await privateAPI.post(
        "/auth/bacchus/client/image/upload",
        formData
      );
      props.productDTO.image = props.productDTO.image ?? [];

      const newArray = [...props.productDTO.image, response.data[0]];
      props.setProductDTO({ ...props.productDTO, image: newArray });
      setLoadingImage(false);
    } catch (e) {
      setLoadingImage(false);
    }
  };

  const openGroupsList = () => {
    setOpenGroupList(true);
    getGroups();
  };

  const getGroups = async () => {
    try {
      setLoading(true);
      const response = await publicAPI.get(`/public/bacchus/productgroup`);
      setAllGroups(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const removeImage = (indexOfImage) => {
    if (props.productDTO.image.length && props.productDTO.image !== "") {
      setLoadingImage(true);
      const newArray = props.productDTO.image.filter(
        (element, index) => index !== indexOfImage
      );
      props.setProductDTO({ ...props.productDTO, image: newArray });
      setLoadingImage(false);
    }
  };

  const handleDrop = (droppedItem) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;
    var updatedList = [...props.productDTO.image];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    props.productDTO.image = updatedList;
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open}
      onClose={props.closeCreateProductDialog}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        align="center"
        style={{ color: "#001753", marginBottom: "15px" }}
      >
        {props.productDTO.id ? "Edit product" : "Create new product"}
      </DialogTitle>
      <DialogContent>
        <Box
          component="form"
          sx={{ display: "flex", flexDirection: "column", padding: "10px" }}
          style={{ minWidth: "300px" }}
          autoComplete="off"
        >
          {/* Commented part: They wanted to change the logic, 
              so that even in editing the product, 
              they could change the group to which it belongs.  
          */}
          {/* {props.productDTO.id ? null : ( */} 
            <Autocomplete
              id="groups-for-product"
              sx={{ width: 300 }}
              open={openGroupList}
              onOpen={() => openGroupsList()}
              onClose={() => {
                setOpenGroupList(false);
              }}
              isOptionEqualToValue={(allGroups, value) =>
                allGroups.name === value.name
              }
              getOptionLabel={(allGroups) => allGroups.name}
              options={allGroups}
              loading={loading}
              style={{ marginBottom: "25px", width: "100%" }}
              onChange={(event, value) =>
                props.setProductDTO({
                  ...props.productDTO,
                  productGroupId: value.id,
                  productGroupName: value.name,
                })
              }
              value={{ name: props.productDTO.productGroupName || '' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Groups"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          {/* )} */}
          <TextField
            id="outlined-basic"
            label="Title of product"
            variant="outlined"
            placeholder="Title of product"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.productDTO.name || ""}
            onChange={(e) =>
              props.setProductDTO({ ...props.productDTO, name: e.target.value })
            }
          />
          <TextField
            id="outlined-basic"
            label="Title on German"
            variant="outlined"
            placeholder="Title on German"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.productDTO.name_de || ""}
            onChange={(e) =>
              props.setProductDTO({
                ...props.productDTO,
                name_de: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="Title on French"
            variant="outlined"
            placeholder="Title on French"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.productDTO.name_fr || ""}
            onChange={(e) =>
              props.setProductDTO({
                ...props.productDTO,
                name_fr: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="Title on Italian"
            variant="outlined"
            placeholder="Title on Italian"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.productDTO.name_it || ""}
            onChange={(e) =>
              props.setProductDTO({
                ...props.productDTO,
                name_it: e.target.value,
              })
            }
          />
          {richTextDesc.map((item) => (
            <React.Fragment key={item.lng}>
              <InputLabel>Description on {item.lng}</InputLabel>
              <ReactQuill
                value={props?.productDTO?.[item.lngSml === "en" ? "description" : `description_${item.lngSml}`] || ""}
                style={{ marginBottom: "25px" }}
                onChange={(e) => updateRichTextContent(e, item.lngSml)}
              />
            </React.Fragment>
          ))}
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={typeOfProduct}
            style={{ marginBottom: "25px", width: "100%" }}
            value={props.productDTO.typeOfProduct || typeOfProduct[0]}
            onChange={(event, value) =>
              props.setProductDTO({
                ...props.productDTO,
                typeOfProduct: value,
              })
            }
            renderInput={(params) => <TextField {...params} label="Type of Product" />}
            />
          <TextField
            id="outlined-basic"
            label="Price"
            placeholder="Price"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.productDTO.price || ""}
            onChange={(e) =>
              props.setProductDTO({
                ...props.productDTO,
                price: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="Liter"
            placeholder="Liter"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.productDTO.liter || ""}
            onChange={(e) =>
              props.setProductDTO({
                ...props.productDTO,
                liter: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="Alcohol Percentage"
            placeholder="Alcohol Percentage"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.productDTO.alcoholPercentage || ""}
            onChange={(e) =>
              props.setProductDTO({
                ...props.productDTO,
                alcoholPercentage: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="Per Serving"
            placeholder="Per Serving"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.productDTO.perServing || ""}
            onChange={(e) =>
              props.setProductDTO({
                ...props.productDTO,
                perServing: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="On stock"
            placeholder="On stock"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.productDTO.stock || 0}
            onChange={(e) =>
              props.setProductDTO({
                ...props.productDTO,
                stock: e.target.value,
              })
            }
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              alignSelf: "flex-end",
            }}
          >
            <p>Discount available: </p>
            <Checkbox
              {...label}
              checked={props?.productDTO.discountMark || false}
              icon={<DiscountIcon style={{ color: "red" }} />}
              checkedIcon={<DiscountIcon style={{ color: "green" }} />}
              onChange={(e) =>
                props.setProductDTO({
                  ...props.productDTO,
                  discountMark: e.target.checked,
                })
              }
            />
          </div>
          <ImageBlockWrapper>
            <DragDropContext onDragEnd={handleDrop}>
              <Droppable droppableId="list-container" direction="horizontal">
                {(provided) => (
                  <div
                    className="item-image-container"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {props.productDTO.image?.length > 0 ? (
                      props.productDTO.image.map((image, index) => (
                        <Draggable
                          key={image}
                          draggableId={image}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.dragHandleProps}
                              {...provided.draggableProps}
                            >
                              <div
                                key={image}
                                style={{
                                  position: "relative",
                                  padding: "10px",
                                }}
                              >
                                {image.includes(
                                  "https://res.cloudinary.com"
                                ) ? (
                                  <img
                                    src={image}
                                    alt="ProductImage"
                                    style={{
                                      height: "100px",
                                      width: "100px",
                                      boxShadow: "1px 1px 1px #ccc",
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  <HideImageIcon
                                    style={{
                                      height: "50px",
                                      width: "50px",
                                      color: "#001753 !important",
                                    }}
                                  />
                                )}
                                <CloseX function={() => removeImage(index)} />
                                <span className="image-order-counter">
                                  {index + 1}
                                </span>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))
                    ) : (
                      <HideImageIcon
                        style={{
                          height: "50px",
                          width: "50px",
                          color: "#001753 !important",
                        }}
                      />
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </ImageBlockWrapper>
          <Button
            variant="contained"
            component="label"
            disabled={props.productDTO.image?.length === 6}
          >
            Upload product image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleUpload(e)}
            />
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.closeCreateProductDialog}>
          Close
        </Button>
        <Button
          onClick={
            props.productDTO.id ? props.editProduct : props.crateNewProduct
          }
          autoFocus
        >
          {props.productDTO.id ? "Edit" : "Create"}
        </Button>
      </DialogActions>
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loadingImage}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default CreateEditProductDialog;
